import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as dayjs from 'dayjs';
import { Button } from '@apmg/titan';
import Icon from '../Icons/Icon';

const WeatherAlert = ({ alert }) => {
  const [hide, setHide] = useState(true);

  const handleClick = () => {
    setHide(!hide);
  };
  const areas = alert.properties.areaDesc.replaceAll(';', ',');

  return (
    <div className="weatherAlert">
      <div
        className="weatherAlert_main"
        onClick={handleClick}
        onKeyDown={handleClick}
        role="presentation"
      >
        <strong>
          {alert.properties.event} for {areas}
        </strong>
        <Button
          aria-haspopup="true"
          aria-expanded={hide ? 'false' : 'true'}
          elementClass={`btn-weatherAlert ${hide ? 'not-active' : 'active'}`}
        >
          <Icon name="chevronDown" elementClass="icon-chevronDown" />
        </Button>
      </div>
      <div className={`weatherAlert_detail ${hide ? 'not-active' : 'active'}`}>
        <div>
          {`Issued for ${alert.properties.areaDesc.replace(
            ';',
            ' &'
          )} at ${dayjs(alert.properties.effective).format(
            'M/D/YYYY @ H:mm A'
          )} until ${dayjs(alert.properties.expires).format(
            'M/D/YYYY @ H:mm A'
          )}`}
        </div>
        <p>{alert.properties.description}</p>
        {alert.properties.instruction && (
          <div className="weatherAlert_instructions">
            <div>INSTRUCTIONS</div>
          </div>
        )}
        {alert.properties.instruction && <p>{alert.properties.instruction}</p>}
      </div>
    </div>
  );
};

WeatherAlert.propTypes = {
  alert: PropTypes.object,
};

export default WeatherAlert;
